import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { APP_PATHS } from "../../../constants/paths";
import { PROMOTION__CRITERIA } from "../../../constants/promotion";
import ProgressBar from "../../UI/ProgressBar/ProgressBar";
import PrimaryButton from "../../UI/PrimaryButton/PrimaryButton";
import coinsIcon from "../../../assets/icons/coins.svg";
import classes from "./Promotion.module.css";

const Promotion = (props) => {
  const { id, name, value, criteriaList } = props;

  const isPromotionAchieved = () => {
    let isAchieved = true;
    criteriaList.forEach((criteria) => {
      if (
        PROMOTION__CRITERIA[criteria.name] &&
        criteria.value < criteria.target
      ) {
        isAchieved = false;
      }
    });
    return isAchieved;
  };

  const getBarText = (criteriaName, value, target) => {
    switch (criteriaName) {
      case PROMOTION__CRITERIA.MTD_Orders_Value:
        return (
          <p
            className={classNames(classes["promotion__bar-text"], {
              [classes["promotion__bar-text--done"]]: value >= target,
            })}
          >
            قيمة الاوردرات <span className="numeric-content">{value}</span> /{" "}
            <span className="numeric-content">{target}</span> جنيه
          </p>
        );

      case PROMOTION__CRITERIA.MTD_Number_Of_Orders:
        return (
          <p
            className={classNames(classes["promotion__bar-text"], {
              [classes["promotion__bar-text--done"]]: value >= target,
            })}
          >
            عدد الاوردرات <span className="numeric-content">{value}</span> /{" "}
            <span className="numeric-content">{target}</span> اوردر
          </p>
        );
      default:
        return "";
    }
  };

  const promotionBarItems = criteriaList.reduce((acc, curr, index) => {
    if (PROMOTION__CRITERIA[curr.name]) {
      return [
        ...acc,
        <li key={index} className={classes["promotion__bar-list-item"]}>
          <ProgressBar progress={curr.value} target={curr.target} />
          {getBarText(curr.name, curr.value, curr.target)}
        </li>,
      ];
    } else {
      return [...acc];
    }
  }, []);

  return (
    <li className={classes["promotion"]} id={`promotion_${id}`}>
      <div className={classes["promotion__name-container"]}>
        <img
          src={coinsIcon}
          alt="coins"
          className={classes["promotion__icon"]}
        />
        <p className={classes["promotion__name"]}>{name}</p>
      </div>
      <ul className={classes["promotion__bar-list"]}>{promotionBarItems}</ul>
      {isPromotionAchieved() ? (
        <p className={classes["promotion__achieved-text"]}>
          انت استفدت بعرض ال <span className="numeric-content">{value}</span>{" "}
          جنيه و سيتم تطبيقه علي طلبك القادم
        </p>
      ) : (
        <Link to={APP_PATHS.HOME.url}>
          <PrimaryButton
            withAnimation
            className={classes["promotion__shop-btn"]}
          >
            إنشاء طلب
          </PrimaryButton>
        </Link>
      )}
    </li>
  );
};

export default Promotion;

Promotion.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  value: PropTypes.number,
  criteriaList: PropTypes.array,
};
